export const renderTermsOfServiceLink = (hostname: string) => {
  if (hostname.includes('kapital')) {
    return `https://${hostname}/brukervilkar`;
  }

  if (hostname.includes('bors')) {
    return 'https://finansavisen.no/vilkar';
  }

  if (hostname.includes('localhost')) {
    return 'https://finansavisen.no/vilkar';
  }

  return `https://${hostname}/vilkar`;
};
